import { registerService } from '@/services/api';
import useSWR from 'swr';
import { config } from '@/config';
import { useRouter } from '@/hooks/general/useRouter/useRouter';

export const useProfessionalDetailsQuestionsQuery = (professionId: number | undefined | null) => {
    const API_URL = config.api.url.registration;
    const router = useRouter();

    const { data } = useSWR(
        professionId ? [`${API_URL}/professional-details-questions`, String(professionId)] : null,
        ([_, professionId]: [_: string, professiondId: string]) =>
            registerService.getProfessionalQuestions(professionId, { routerPush: router.push }),
    );

    return data;
};
